export default __webpack_public_path__ + "static/media/live-recorded-interview.a0c15222.svg";